import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import mlbLogo from '@sorare/core/src/assets/logos/mlb/mlb.svg';
import nbaLogo from '@sorare/core/src/assets/logos/nba/nba.svg';
import { Header as ScoutingCenterHeader } from '@sorare/marketplace/src/searchCommonPlayer/Header';

import mlbBg from './assets/mlb-bg.webp';
import nbaBg from './assets/nba-bg.webp';

const images = {
  [Sport.NBA]: {
    background: nbaBg,
    logo: nbaLogo,
  },
  [Sport.BASEBALL]: {
    background: mlbBg,
    logo: mlbLogo,
  },
  [Sport.FOOTBALL]: {
    background: 'var(--c-nd-100)',
    logo: '',
  },
};

export const Header = ({ sport }: { sport: Sport }) => {
  const { background, logo } = images[sport];
  return (
    <ScoutingCenterHeader
      fixed
      leagueLogo={{ src: logo, alt: '' }}
      backgroundImage={background}
    />
  );
};
